export default __webpack_public_path__ + "6121a00507b268ed5d2bb6abf4e047ed.png";